
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { ExchangePlatform } from '@/types/trader';
import { useTranslation } from 'react-i18next';

interface ExchangeBadgesProps {
  exchanges: ExchangePlatform[];
}

export const ExchangeBadges: React.FC<ExchangeBadgesProps> = ({ exchanges }) => {
  const { t } = useTranslation();

  if (!exchanges || exchanges.length === 0) {
    return null;
  }
  
  return (
    <div className="flex flex-wrap gap-1">
      {exchanges.slice(0, 3).map((platform, index) => (
        <Badge key={index} variant="outline" className="bg-background/50">
          {platform}
        </Badge>
      ))}
      {exchanges.length > 3 && (
        <Badge variant="outline" className="bg-background/50">
          {t('more_exchanges', { count: exchanges.length - 3 })}
        </Badge>
      )}
    </div>
  );
};
